
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.184","height":"14.184"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19279","data-name":"Path 19279","d":"M4.137 8.274a.591.591 0 01-.591.591h-.591a.591.591 0 010-1.182h.591a.591.591 0 01.591.591zM6.5 7.683h-.59a.591.591 0 000 1.182h.59a.591.591 0 000-1.182zm-2.954 2.364h-.591a.591.591 0 000 1.182h.591a.591.591 0 000-1.182zm2.955 0H5.91a.591.591 0 000 1.182h.59a.591.591 0 000-1.182zM3.546 2.955h-.591a.591.591 0 000 1.182h.591a.591.591 0 000-1.182zm2.955 0H5.91a.591.591 0 000 1.182h.59a.591.591 0 000-1.182zM3.546 5.319h-.591a.591.591 0 000 1.182h.591a.591.591 0 000-1.182zm2.955 0H5.91a.591.591 0 000 1.182h.59a.591.591 0 000-1.182zm7.683.591v5.319a2.958 2.958 0 01-2.955 2.955H2.955A2.958 2.958 0 010 11.229V2.955A2.958 2.958 0 012.955 0H6.5a2.958 2.958 0 012.956 2.955h1.773a2.958 2.958 0 012.955 2.955zM2.955 13h5.319V2.955A1.773 1.773 0 006.5 1.182H2.955a1.773 1.773 0 00-1.773 1.773v8.274A1.773 1.773 0 002.955 13zM13 5.91a1.773 1.773 0 00-1.773-1.773H9.456V13h1.773C12.208 13 13 11.229 13 11.229zm-1.771 1.773a.591.591 0 10.591.591.591.591 0 00-.591-.591zm0 2.364a.591.591 0 10.591.591.591.591 0 00-.591-.591zm0-4.728a.591.591 0 10.591.591.591.591 0 00-.591-.591z","fill":"#5f6368"}})])
          )
        }
      }
    